/**
 * Uppercase the first letter
 *
 * @param str
 * @returns {string}
 */
export default function upperFirst(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
